
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import UserService from "./services/user.service";
import MessageBox from './MessageBox';

import { Container, Form, FormLabel, Row, Col } from "react-bootstrap"
import Alert from 'react-bootstrap/Alert'
import { login } from "./actions/auth.js";
import { logout } from "./actions/auth.js";
import { register } from "./actions/auth.js";
import { App, WrapperApp } from "./App.js"

const RegistroNuevoUsuario = () => {

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      primernombre: "",
      primerapellido: "",
      segundonombre: "",
      segundoapellido: "",
      curp: "",
      fechadenacimiento: "",
      telefonomovil: "",
      email: "",
      contraseña: "",
      confirmarcontraseña: "",
      bio: ""
    },
  });  

  const [primernombre, setPrimernombre] = useState("");
  const [segundonombre, setsegundonombre] = useState("");
  const [primerapellido, setprimerapellido] = useState("");
  const [segundoapellido, setsegundoapellido] = useState("");
  const [fechadenacimiento, setfechadenacimiento] = useState(null);
  const [curp, setcurp] = useState("");
  const [telefonomovil, settelefonomovil] = useState("");
  const [arean1, setarean1] = useState(null);
  const [arean2, setarean2] = useState(null);
  const [imageprofile, setimageprofile] = useState("");
  const [bio, setbio] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [genero, setgenero] = useState("");
  
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  

  const { isLoggedIn } = useSelector(state => state.auth);
  const { user: currentUser } = useSelector((state) => state.auth);	
  const [user, setUser] = useState({});  

  const { message } = useSelector(state => state.message);

  const dispatch = useDispatch();

  const onChangeprimernombre = (e) => {  
    //console.log(e.target.value);
    const primernombre = e.target.value;
    setPrimernombre(primernombre);
  };
  
  const onChangeprimerapellido = (e) => {  
    //console.log(e.target.value);
    const primerapellido = e.target.value;
    setprimerapellido(primerapellido);
  };
  
  const onChangeimageprofile = (e) => {  
    //console.log(e.target.value);
    const imageprofile = e.target.value;
    setimageprofile(imageprofile);
  };  
  
  const onChangeemail = (e) => {  
    //console.log(e.target.value);
    const email = e.target.value;
    setemail(email);
  };

  const onChangePassword = (e) => {
    //console.log(e.target.value);
    const pass = e.target.value;
    setpassword(pass);
  };

  const onChangeConfirmPassword = (e) => {
    //console.log(e.target.value);
    const confirmpass = e.target.value;
    setconfirmpassword(confirmpass);
  };
  

  const handleRegister = (e) => {
    //e.preventDefault();

    setLoading(true);
    
    if (!loading) {
      dispatch(register(e.primernombre, e.primerapellido, e.email, e.contraseña, e.confirmarcontraseña, [2]))
        .then(() => {
          console.log("registered");
          //props.history.push("/");
          //window.location.reload();
          
          //console.log("registered");
          //setShowsuccess(true);
          //setSuccmessage("Se registró el usuario correctamente. Por favor ingresa a tu cuenta con el usuario y contraseña que diste de alta.");
          //window.location.assign("/login");
          dispatch(login(e.email, e.contraseña))
            .then(() => {
              //props.history.push("/");
              //window.location.assign("/viewuserprofile/" + isLoggedIn.id);
              ////window.location.reload();
            })
            .catch(() => {
              setLoading(false);
            });
        })
        .catch((err) => {
          console.log("registration error:", err);
          setLoading(false);
          /*
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage(err);
          */
        });
    } 
    else {
      setLoading(false);
    }
  };

  if (isLoggedIn) { 
    //window.location.reload();
    //return <Navigate to="/" />;
    
    ////return <WrapperApp user={user}/>;    
    //return <App user={user}/>;    
    //console.log("isLoggedIn:", currentUser);
    window.location.assign("/viewuserprofile/" + currentUser.id);
  };

  return (
    <>
    
    <div className="col-md-12" style={{zIndex:1}}>
      <img src="./design.png" style={{opacity:'0.1', position:'absolute',width:'100%',top:'0',left:'0',height:'100vh',overflow:'hidden',objectFit:'cover'}}/>
      <div 
        className="card card-container"
        style={{maxWidth:'850px',padding:'20px 20px', backgroundColor:'lightgray'}}
      >
      <div className='m-2' style={{textAlign:'center'}}>
        <img src="./logo192.png" width={"120px"}/>
        <hr />
        <h6>Creating an account allows you to configure a kitchen for your project and get an instant quote!</h6>
        {/*<div>Please provide the following information to create your account.</div>*/}
      </div>      

      <Container>
        <hr />
        <Form noValidate onSubmit={handleSubmit(handleRegister)}>
          <div style={{display:'flex',flexDirection:'row', alignItems:'center',flexWrap:'wrap',justifyContent:'space-between'}}>
            <Col className='col-md-3' lg={12}>
                <Controller
                  name="primernombre"
                  control={control}
                  onChange={onChangeprimernombre}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                        className="m-2"
                        type="text"
                        placeholder="First Name"
                        isInvalid={errors.primernombre}
                        //onChange={onChangeprimernombre}
                        //value={username}
                        
                    />
                  )}
                />
                {errors.primernombre && (
                  <Form.Control.Feedback type="invalid">
                    First name is required
                  </Form.Control.Feedback>
                )}
            </Col>

            <Col className='col-md-3' lg={12}>
              <Controller
                name="primerapellido"
                control={control}
                onChange={onChangeprimerapellido}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      placeholder="Last Name"
                      isInvalid={errors.primerapellido}
                      //onChange={onChangeprimerapellido}
                      //value={username}
                      
                  />
                )}
              />
              {errors.primerapellido && (
                <Form.Control.Feedback type="invalid">
                  Last name is required
                </Form.Control.Feedback>
              )} 
            </Col>

            <Col className='col-md-3' lg={12}>
              <Controller
                name="email"
                control={control}
                onChange={onChangeemail}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      placeholder="Email"
                      isInvalid={errors.email}
                      //onChange={onChangeemail}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.email && (
                <Form.Control.Feedback type="invalid">
                  Email is required.
                </Form.Control.Feedback>
              )} 
            </Col>              

          </div>

          <Row>

            <Col className='col-md-3' lg={12}>
              <FormLabel className="m-2">Password</FormLabel>
              <Controller
                name="contraseña"
                control={control}
                onChange={onChangePassword}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="password"
                      isInvalid={errors.contraseña}
                      //onChange={onChangePassword}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.contraseña && (
                <Form.Control.Feedback type="invalid">
                  You must provide a password.
                </Form.Control.Feedback>
              )} 
            </Col>  


            <Col className='col-md-3' lg={12}>
              <FormLabel className="m-2">Confirm Password</FormLabel>
              <Controller
                name="confirmarcontraseña"
                control={control}
                onChange={onChangeConfirmPassword}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="password"
                      isInvalid={errors.confirmarcontraseña}
                      //onChange={onChangeConfirmPassword}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.confirmarcontraseña && (
                <Form.Control.Feedback type="invalid">
                  You must confirm your password.
                </Form.Control.Feedback>
              )} 
            </Col>                
          </Row>
       
          <div className="form-group m-2">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Create Account</span>
            </button>
          </div> 

          <Row className='mt-2'>

            {showerror && (
              <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                onHide={() => {
                  setShowerror(false)
                }}
              />
            )}
            {showsuccess && (

              <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                onHide={() => {
                setShowsuccess(false);
                window.location.reload();
              }}
              />
            )}

            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}            

          </Row>  
          
          <hr />
          <span style={{fontSize:'14px'}}>
            Already have an account? Log in <a href="/login">here</a>.
          </span>                  
        </Form>
      </Container>
      </div>

    </div>
    </>
  );
};




export default RegistroNuevoUsuario;
